<div style="height: 100%;">
  
  @for (item of dummydata; track $index) {
  <ion-card class="card-builder-properties">
    <ion-card-content>
      <ion-row>
      
        <ion-col push="10" size="2" style="text-align: end;" >
          <ion-skeleton-text style="height: 25px;width: 50px;">
            
          </ion-skeleton-text>
          
        </ion-col>
      </ion-row>
   
      <ion-row>
        <ion-col class="ion-no-padding" style="text-align: center;">
          <div class="div-long-text"><ion-skeleton-text 
              [animated]="true"></ion-skeleton-text></div>
          <div class="div-long-text"><ion-skeleton-text style="width: 160px;"
              [animated]="true"></ion-skeleton-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-no-padding col-builder-pro">
          <div style="display: flex;"> <ion-skeleton-text [animated]="true"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" style="margin-left: 10px;"></ion-skeleton-text>
          </div>

          <div style="display: flex;"><ion-skeleton-text class="title-text">
            </ion-skeleton-text>
            <ion-skeleton-text [animated]="true"></ion-skeleton-text>
          </div>
          <div style="display: flex;"> <ion-skeleton-text [animated]="true"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" style="margin-left: 10px;"></ion-skeleton-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
      
        <ion-col push="8" size="4" style="display: inline-flex;" >
          <ion-skeleton-text style="height: 25px;width: 50px;">
            
          </ion-skeleton-text>
          <ion-skeleton-text  style="margin-left: 10px;height: 25px;width: 50px;">
           
          </ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
  }

</div>
